import { 
  collection, 
  addDoc, 
  getDocs, 
  getDoc,      // ← ADD THIS LINE
  doc, 
  deleteDoc, 
  query,
  where,
  Timestamp,
  setDoc
} from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Get start and end of week for a given date
 */
function getWeekBounds(date = new Date()) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Adjust to Monday
  
  const monday = new Date(d.setDate(diff));
  monday.setHours(0, 0, 0, 0);
  
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  sunday.setHours(23, 59, 59, 999);
  
  return { monday, sunday };
}

/**
 * Create a unique ID for a specific date
 */
function getDateId(date) {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/**
 * Assign a recipe to a specific date
 */
export async function assignRecipeToDate(userId, date, recipeId) {
  try {
    const dateId = getDateId(date);
    const docId = `${userId}_${dateId}`;
    
    console.log('💾 assignRecipeToDate called:', { 
      userId, 
      date, 
      dateId, 
      docId, 
      recipeId,
      dateType: typeof date,
      isDate: date instanceof Date
    });
    
    const docRef = doc(db, 'mealPlans', docId);
    
    await setDoc(docRef, {
      userId,
      date: Timestamp.fromDate(new Date(date)),
      dateId,
      recipeId,
      createdAt: Timestamp.now()
    });
    
    console.log('✅ Document saved to Firestore:', docId);
    
    // Verify it was actually saved
    const checkDoc = await getDoc(docRef);
    if (checkDoc.exists()) {
      console.log('✅ Verified document exists:', checkDoc.data());
    } else {
      console.error('❌ Document was NOT saved!');
    }
    
    return { success: true };
  } catch (error) {
    console.error('❌ Error assigning recipe:', error);
    throw error;
  }
}

/**
 * Remove meal plan for a specific date
 */
export async function removeMealPlan(userId, date) {
  try {
    const dateId = getDateId(date);
    const docId = `${userId}_${dateId}`;
    
    console.log('🗑️ removeMealPlan called:', { 
      userId, 
      date, 
      dateId, 
      docId,
      dateType: typeof date,
      isDate: date instanceof Date
    });
    
    await deleteDoc(doc(db, 'mealPlans', docId));
    console.log('✅ Document deleted:', docId);
    return { success: true };
  } catch (error) {
    console.error('❌ Error removing meal plan:', error);
    throw error;
  }
}

/**
 * Get meal plans for current week
 */
export async function getWeekMealPlans(userId, weekDate = new Date()) {
  try {
    const { monday, sunday } = getWeekBounds(weekDate);
    
    console.log('getWeekMealPlans querying:', { 
      userId, 
      weekDate,
      monday, 
      sunday 
    });
    
    const q = query(
      collection(db, 'mealPlans'),
      where('userId', '==', userId),
      where('date', '>=', Timestamp.fromDate(monday)),
      where('date', '<=', Timestamp.fromDate(sunday))
    );

    const querySnapshot = await getDocs(q);
    const mealPlans = {};

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      console.log('Found meal plan:', { docId: doc.id, data });
      mealPlans[data.dateId] = {
        id: doc.id,
        recipeId: data.recipeId,
        date: data.date.toDate()
      };
    });

    console.log('Final mealPlans:', mealPlans);
    return mealPlans;
  } catch (error) {
    console.error('Error getting meal plans:', error);
    throw error;
  }
}

/**
 * Get all recipe IDs for the week (for shopping list)
 */
export async function getWeekRecipeIds(userId, weekDate = new Date()) {
  try {
    const mealPlans = await getWeekMealPlans(userId, weekDate);
    return Object.values(mealPlans).map(plan => plan.recipeId);
  } catch (error) {
    console.error('Error getting week recipe IDs:', error);
    throw error;
  }
}
